module.exports = __webpack_public_path__ + "img/3-mob.32288166.png";